import { NewsletterWithStatsDto } from "types/Newsletter"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const bulletinsReducer: RemoteReducer<NewsletterWithStatsDto[]> =
  createRemoteReducer("bulletins")
